module.exports = __webpack_public_path__ + "static/img/zz-02.03dc4b9a.jpg";